// Generated by CoffeeScript 2.7.0
//TODO: merge with components/color_picker
var TagsModal, color_picker_comp, editing_list_item_comp, modal_comp, popover_comp, tag_comp, tag_group_comp;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ColorPicker from 'trunks/vue/admin/components/icon_color_picker.js';

import {
  EditingListItemMixin,
  EditingListItem
} from 'trunks/vue/admin/components/editing_list_item.js';

editing_list_item_comp = EditingListItem;

modal_comp = Modal;

color_picker_comp = ColorPicker;

popover_comp = Popover;

tag_comp = {
  components: {
    'editing-list-item': editing_list_item_comp,
    'color-picker': color_picker_comp,
    'popover': popover_comp
  },
  props: {
    tag: {
      type: Skylark.App.BaseModel
    }
  },
  mixins: [EditingListItemMixin],
  template: `<editing-list-item itemClass='tag-item'
                   :item='tag'
                   :editingVm='editingVm'
                   inputPlaceholder='请输入标签名称'
                   ref='editingListItemRef'
                   @destroyed='destroyedFunc'
                   @inputChanged='inputChangedFunc'
                   @editingVmChanged='editingVmChangedFunc'
                   @addNewItem='addNewItemFunc'>
  <template slot='tip-template' slot-scope='{ editing, item }'>
    <i v-show='!editing' class='slp-origin' :style="{ color: item.color }" ></i>
    <popover v-show='editing'
             :caret='false'
             customClass='color-picker-popover'
             position='bottom left'
             ref='colorPickerPopover'>
      <template slot='trigger'>
        <span class='btn icon-btn btn-small'>
          <i class='slp-circle editing' :style="{ color: tag.color }" ></i>
        </span>
      </template>
      <template slot='content'>
        <color-picker pickerMode='color'
                      :pickedColor='tag.color'
                      @colorChanged='changeColorFunc' />
      </template>
    </popover>
  </template>
</editing-list-item>`,
  methods: {
    inputChangedFunc: function(value) {
      return this.tag.name = value;
    },
    destroyedFunc: function() {
      return newConfirm({
        title: '删除标签',
        message: '同时删除消息已标记的标签',
        confirmButtonText: '我知道了',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this.tag.destroy();
      });
    },
    changeColorFunc: function(color) {
      this.tag.name = this.$refs.editingListItemRef.getInputValue();
      this.tag.color = color;
      return this.$nextTick(function() {
        this.$refs.colorPickerPopover.close();
        return this.$refs.editingListItemRef.edit();
      });
    }
  }
};

tag_group_comp = {
  props: {
    tagGroup: {
      type: Skylark.App.BaseModel
    }
  },
  mixins: [EditingListItemMixin],
  components: {
    'tag': tag_comp,
    'editing-list-item': editing_list_item_comp
  },
  data: function() {
    return {
      isOpen: true
    };
  },
  template: `<div class='tag-group-wrapper'>
  <div class='tag-group'>
    <editing-list-item itemClass='tag-group-item'
                      :item='tagGroup'
                      :editingVm='editingVm'
                      inputPlaceholder='请输入标签分组名称'
                      ref='editingListItemRef'
                      @destroyed='destroyedFunc'
                      @inputChanged='inputChangedFunc'
                      @itemClicked='toggleTagsFunc'
                      @addNewItem='addNewTagGroupFunc'
                      @editingVmChanged='editingVmChangedFunc'>
      <template slot='tip-template' slot-scope='{ editing }'>
        <i v-show='!editing' :class="{ 'slp-chevron-down': !isOpen, 'slp-chevron-up': isOpen }"></i>
        <i v-show='editing' :class="{ 'slp-chevron-down': !isOpen, 'slp-chevron-up': isOpen }"></i>
      </template>
      <template slot='additional-actions'>
        <div class='btn icon-btn btn-small' @click.stop='addNewTagFunc'><i class='slp-plus'></i></div>
      </template>
    </editing-list-item>
    <div v-show='isOpen' class='tags list sub-list'>
      <tag v-for='tag in filterTags'
          :key='tag.uuid'
          :tag='tag'
          :editingVm='editingVm'
          @editingVmChanged='updateEditingVmFunc'
          @addNewItem='addNewTagFunc'/>
    </div>
  </div>
</div>`,
  computed: {
    filterTags: function() {
      return _.filter(this.tagGroup.tags, function(tag) {
        return !tag._destroy;
      });
    }
  },
  methods: {
    inputChangedFunc: function(value) {
      return this.tagGroup.name = value;
    },
    destroyedFunc: function() {
      return newConfirm({
        title: '删除标签分组',
        message: '此分组下所有标签将会被删除',
        confirmButtonText: '我知道了',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this.tagGroup.destroy();
      });
    },
    updateEditingVmFunc: function(vm) {
      if (!this.isOpen) {
        this.toggleTagsFunc();
      }
      return this.$emit('editingVmChanged', vm);
    },
    toggleTagsFunc: function() {
      if (this.editingVm) {
        return;
      }
      if (!(this.$refs.editingListItemRef.editing || _.isEmpty(this.filterTags))) {
        return this.isOpen = !this.isOpen;
      }
    },
    addNewTagFunc: function() {
      return this.tagGroup.tags.push(new Skylark.App.Model.Tag());
    },
    addNewTagGroupFunc: function() {
      return this.$emit('addNewGroup');
    }
  }
};

export default TagsModal = Vue.extend({
  components: {
    'modal': modal_comp,
    'tag-group': tag_group_comp
  },
  props: {
    rawTagGroups: Array,
    updateUrl: String
  },
  data: function() {
    return {
      tagGroups: _.map(this.rawTagGroups, function(tag_group) {
        return new Skylark.App.Model.TagGroup(tag_group);
      }),
      editingVm: null,
      extendClass: ['tags-modal', 'large-modal']
    };
  },
  template: `<modal title='标签管理'
       :extendClass='extendClass'
       :backdrop='true'
       ensureText='保存'
       ref='modal'
       @ensureClicked='submit'>
  <div class='sticky-wrapper'>
    <div class='sticky-content'>
      <div class='new-tag-group-btn vertical-middle' @click='addNewTagGroupFunc'>
        <i class='slp-plus'></i>
        <span>新建标签分组</span>
      </div>
    </div>
    <div class='scroll-container'>
      <div v-if='_.isEmpty(this.filterTagGroups)' class='blankslate'>
        <p>没有“标签分组”</p>
      </div>
      <div v-else class='tag-groups list'>
        <tag-group v-for='tagGroup in this.filterTagGroups'
                   :key='tagGroup.uuid'
                   :tagGroup='tagGroup'
                   :editingVm='editingVm'
                   @addNewGroup='addNewTagGroupFunc'
                   @editingVmChanged='updateEditingVmFunc'/>
      </div>
    </div>
  </div>
</modal>`,
  computed: {
    filterTagGroups: function() {
      return _.filter(this.tagGroups, function(tagGroup) {
        return !tagGroup._destroy;
      });
    }
  },
  watch: {
    editingVm: function(val, oldVal) {
      return this.extendClass = _.isEmpty(val) ? ['tags-modal', 'large-modal'] : ['tags-modal', 'large-modal', 'editing'];
    }
  },
  methods: {
    addNewTagGroupFunc: function() {
      if (_.isEmpty(this.editingVm)) {
        return this.tagGroups.push(new Skylark.App.Model.TagGroup());
      }
    },
    updateEditingVmFunc: function(vm) {
      return this.editingVm = vm;
    },
    toJSON: function() {
      if (this.editingVm) {
        this.editingVm.update();
      }
      return _.chain(this.tagGroups).filter(function(tagGroup) {
        return tagGroup.isPersisted() || !tagGroup._destroy;
      }).map(function(tagGroup) {
        return tagGroup.toJSON();
      }).value();
    },
    submit: function() {
      return Skylark.Libs.Ajax.put(this.updateUrl, {
        responseType: 'script',
        contentType: "application/json; charset=UTF-8",
        data: {
          tag_groups: this.toJSON()
        },
        success: function() {
          return newAlertify('保存成功', {
            type: 'success'
          });
        },
          error: function() {
            return newAlertify('标签更新失败', {
              type: 'danger'
            });
          }
      });
    }
  }
});
